import { Box, styled, Typography } from "@material-ui/core";

export const TTHTContainer = styled("div")(({ theme }) => ({
  flexDirection: "column",
  display: "flex",
  width: "100%",
}));

export const TTHTSection = styled(Box)(({ theme }) => ({
  justifyContent: "center",
  display: "flex",
  width: "100%",
}));

export const TTHTSectionWrapper = styled("div")({
  justifyContent: "center",
  alignItems: "flex-end",
  maxWidth: "1140px",
  display: "flex",
});

export const TTHTSectionContent = styled(Box)(({ theme }) => ({
  width: "100%",
  padding: theme.spacing(9),
  paddingTop: theme.spacing(5),
  paddingBottom: theme.spacing(5),
}));

export const TTHTSectionText = styled(Typography)(({ theme, bold }) => ({
  marginBottom: theme.spacing(2),
  fontSize: theme.typography.body1.fontSize,
  color: theme.palette.secondary.main,
  ...(bold && { fontWeight: theme.typography.fontWeightBold }),
}));

export const TTHTSectionTitle = styled(Typography)(({ theme, size }) => ({
  fontSize: theme.typography[size === "sm" ? "h5" : "h4"].fontSize,
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.primary.main,
  marginBottom: theme.spacing(2),
}));

export const TTHTSectionSubTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.body1.fontSize,
  fontWeight: theme.typography.fontWeightBold,
}));

export const TTHTNumber = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.common.white,
  justifyContent: "center",
  borderRadius: "0.75rem",
  alignItems: "center",
  textAlign: "center",
  display: "flex",
  height: "1.5rem",
  width: "1.5rem",
}));

export const HideOnBreakpoint = styled("div")(
  ({ theme, breakpoint, action = "down" }) => ({
    [`${theme.breakpoints[action](breakpoint)}`]: {
      display: "none",
    },
  })
);



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/TeachersToolkitHowTo/TeachersToolkitHowTo.styled.js